import { render, staticRenderFns } from "./ComplaintHandlingDashboard.vue?vue&type=template&id=02cc5bfe&scoped=true&"
import script from "./ComplaintHandlingDashboard.vue?vue&type=script&lang=js&"
export * from "./ComplaintHandlingDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cc5bfe",
  null
  
)

export default component.exports